import { formatNumber } from "@/utils/numberFormat";
import { convertValue } from "@/utils/unitConverter";
import { getUnitLabel } from "@/utils/unitFormatter";

import FormSummary from "@/components/desktop/form/modal/FormSummary/FormSummary";

import useFilterStore from "@/stores/useFilterStore";

const IOSummary = ({ application }) => {
	const { filter } = useFilterStore();
	const unitMeasurement = filter?.unit_measurement || "kg_l";

	let netValue = application.product_net_content || 0;
	if (application.product_unit_measurement !== "u") {
		netValue = convertValue(netValue, application.product_unit_measurement, unitMeasurement);
	}

	const items = [
		{ label: "Producto", value: application.product_name },
		{
			label: "Cont. Neto",
			value: `${formatNumber(netValue, 2)}${getUnitLabel(application.product_unit_measurement, unitMeasurement)}`,
		},
		{ label: "Código Producto", value: application.product_code },
		{ label: "Código Salida", value: application.output_code },
		{ label: "Usuario", value: application.user_name },
	];

	const badge = {
		text: application.entry ? "Entrada" : "Salida",
		variant: application.application_type_id === 1 ? "success" : "warning",
	};

	const variant = application.application_type_id === 1 ? "success" : "warning";

	return <FormSummary items={items} badge={badge} variant={variant} />;
};

export default IOSummary;
